"use strict";

export default class VehicleGroups {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  getVehicleGroups(vehicleIds, groupIds, searchTerm, paging, targetAccount = null) {
    let deferred = this.$q.defer();
    let url = "v1/vehicle-groups";

    let param = [];
    param.push.apply(param, this.API.getPagingQuery(paging));
    param.push.apply(param, this.API.getArrayQuery("vehicleId", vehicleIds));
    param.push.apply(param, this.API.getArrayQuery("groupId", groupIds));
    if (searchTerm) param.push("searchTerm=" + searchTerm);

    if (targetAccount !== null)
      param.push("targetAccount=" + targetAccount);

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((vehicles) => {
        //console.log("vehicle groups: ", vehicles);
        deferred.resolve(vehicles);

      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }

  getById(groupId, targetAccount = null) {
    let deferred = this.$q.defer();
    let url = "v1/vehicle-groups/" + groupId;

    let param = [];
    if (targetAccount !== null)
      param.push("targetAccount=" + targetAccount);

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((vehicle) => deferred.resolve(vehicle))
      .error((err) => deferred.reject(err));

    return deferred.promise;
  }
}

VehicleGroups.$inject = ["$q", "FleetPortalAPI"];



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.vehicle-groups.js